import React from "react";

const SvgWithLabels = ({ company, score }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1165.55 345.25">
    <defs>
        <style>
        {`
          .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {
            fill: #fff;
          }
          .cls-1, .cls-3 {
            font-family: SFPro-Regular, 'SF Pro';
            font-size: 31px;
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 400;
          }
          .cls-2 {
            font-family: SFPro-Medium, 'SF Pro';
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 510;
            font-weight: 500;
          }
          .cls-5, .cls-6 {
            font-family: SFPro-Bold, 'SF Pro';
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 700;
            font-weight: 700;
          }
          .cls-5 {
            font-size: 25px;
          }
          .cls-6 {
            font-size: 28.71px;
          }
          .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {
            stroke-miterlimit: 10;
          }
          .cls-7, .cls-9, .cls-12, .cls-13 {
            fill: none;
            stroke: #f2f2f2;
          }
          .cls-8 {
            fill: #084891;
            stroke: #fff;
            opacity: .4;
          }
          .cls-10 {
            fill: #44adff;
            stroke: #fff;
          }
          .cls-11 {
            fill: #0994ff;
            stroke: #fff;
            opacity: .4;
          }
          .cls-14 {
            fill: #007aff;
            stroke: #fff;
            opacity: .4;
          }
          .cls-9 {
            stroke-dasharray: 4.62 4.62;
          }
          .cls-12 {
            stroke-dasharray: 4 4;
          }
          .cls-13 {
            stroke-dasharray: 4.02 4.02;
          }
        `}
      </style>
    </defs>

    {/* Boxes */}
    <rect className="cls-9" x="38.02" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-12" x="311.34" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-11" x="584.66" y="20.05" width="273.32" height="112.94" />
    <rect className="cls-8" x="857.97" y="20.05" width="273.32" height="112.94" />

    {/* Labels inside boxes */}
    <text className="cls-1" transform="translate(121.8 84.97)">Outpost</text>
    <text className="cls-1" transform="translate(396.68 87.44)">
      <tspan>Sa</tspan><tspan x="33.95">t</tspan><tspan x="42.84">elli</tspan><tspan x="77.76">t</tspan><tspan x="86.64">e</tspan>
    </text>
    <text className="cls-1" transform="translate(636.57 87.44)">
      <tspan x="0">P</tspan><tspan x="17.15">o</tspan><tspan x="33.6">r</tspan><tspan x="43.91">t</tspan><tspan x="53.25">f</tspan><tspan x="61.15">olio Hub</tspan>
    </text>
    <text className="cls-3" transform="translate(867.47 87.44)">
      <tspan x="0">T</tspan><tspan x="14.53">r</tspan><tspan x="23.78">ans</tspan><tspan x="70.1">f</tspan><tspan x="78">ormation Hub</tspan>
    </text>

    {/* Arrows and dashed lines */}
    <line className="cls-7" x1="311.34" y1="171.58" x2="311.34" y2="173.58" />
    <line className="cls-10" x1="311.34" y1="178.2" x2="311.34" y2="194.37" />
    <polyline className="cls-7" points="311.34 196.68 311.34 198.68 313.34 198.68" />
    <line className="cls-14" x1="317.36" y1="198.68" x2="580.65" y2="198.68" />
    <polyline className="cls-7" points="582.66 198.68 584.66 198.68 584.66 196.68" />
    <line className="cls-10" x1="584.66" y1="192.06" x2="584.66" y2="175.89" />
    <line className="cls-7" x1="584.66" y1="173.58" x2="584.66" y2="171.58" />
    <line className="cls-13" x1="448" y1="227.39" x2="448" y2="201.68" />
    <polygon className="cls-4" points="439.33 227.92 448 239.48 456.67 227.92 439.33 227.92" />

    {/* Numbers under each block */}
    <text className="cls-6" transform="translate(30.94 162.07)">1</text>
    <text className="cls-6" transform="translate(302.68 162.07)">2</text>
    <text className="cls-6" transform="translate(575.61 162.07)">3</text>
    <text className="cls-6" transform="translate(848.68 162.07)">4</text>
    <text className="cls-6" transform="translate(1122.32 162.07)">5</text>

    {/* Dynamic Text Props */}
    <text class="cls-2" transform="translate(357.14 282.33)">
      <tspan x="60" y="0">{company}</tspan>
    </text>
    <text class="cls-2" transform="translate(404.24 319.19)">
      <tspan x="-20" y="0">Maturity Index: {score}</tspan>
    </text>
  </svg>
);

export default SvgWithLabels;
